import { Component, type ErrorInfo, type ReactNode } from "react";
import { Sentry } from "../app/monitoring";

interface Props { children: ReactNode }
interface State { failed: boolean }

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State { return { failed: true }; }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack } } });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="fatal-error" role="alert"><div className="empty-state"><h1>Something went wrong</h1><p>The page could not be displayed. Your saved data was not changed.</p><div className="button-group"><button className="button primary" onClick={() => this.setState({ failed: false })}>Try Again</button><button className="button" onClick={() => { window.location.hash = "/today"; window.location.reload(); }}>Return to Today</button></div></div></main>;
  }
}
